export const navigationLinks: { text: string; to: string; isExternal?: boolean; link?: string }[] = [
	{ text: 'Home', to: 'header' },
	{ text: 'About', to: 'about' },
	{ text: 'Projects', to: 'projects' },
	{ text: 'Resume', to: 'resume', isExternal: true, link: '/assets/Saul_Plateros_Resume_Web.pdf' },
];
